<template>
    <el-dialog
        visible
        width="35%"
        :close-on-click-modal="false"
        append-to-body
        :before-close="close">
        <template #title>
            <UploadTitleTips></UploadTitleTips>
        </template>
        <div class="GuidanceTooltip">
          <div class="guide-tip">
            <GuidanceTooltip
                :size='24'
                :content="$t('setFileAndDownloadTipHtml')"
                :jumpLink="$t('setFileAndDownloadTipLink')"
            ></GuidanceTooltip>
          </div>
          <div v-html="$t('split_file_tip')" class="guide-content-container"></div>
        </div>
        <el-upload class="upload-drag"
                   ref="uploadLog"
                   :headers="headers"
                   :on-remove="handleRemove"
                   :data="{
                      siteId:getSite.siteId,
                      secondMilestoneId:secondMilestoneId,
                      statutoryId:rowData.id,
                      zipFlag: 0
                    }"
                   :show-file-list="false"
                   :file-list="hereFilelist"
                   :limit="500"
                   :on-progress="uploading"
                   :on-change="uploadchange"
                   :on-success="handleUploadSuccess"
                   :before-upload="beforeFileUpload"
                   drag
                   :action="actionUrl"
                   :auto-upload="true"
                   multiple>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text" style="word-break: break-word;font-size: 14px"><em> {{$t('PAGE_PBC_UPLOAD_text1')}}{{$t('PAGE_PBC_UPLOAD_text2')}}</em></div>
            <div class="el-upload__tip upload-rule-text">
                {{$t('PAGE_PBC_UPLOAD_TIP_1')}}
            </div>
        </el-upload>
        <!--    上传文件列表-->
        <div class="overflow-fileList-container"  v-if="hereFilelist.length" :style="{ height: (hereFilelist.length * 60) + 'px;'}">
            <div v-for="hereFilelist in hereFilelist" :key="hereFilelist.uid" class="border-file" :style="{ height: hereFilelist.status === 'uploading' && hereFilelist.percentage !== 100 ? '55px;' : '40px;'}">
                <div class="uploaded-cls" :title="hereFilelist.name">
                    <svg-icon :icon-name="getUploadFileIcon(hereFilelist.name)" :size="24" style="margin-left: 10px;"></svg-icon>
                    <span class="upload-filename">{{ hereFilelist.name }}</span>
                    <div v-if="hereFilelist.status === 'success'" style="margin-right: 10px;margin-left: auto;display: grid;grid-template-columns: 1fr 1fr;">
                        <template>
                            <svg-icon icon-name="upload-success" :size="16" style="margin-right: 5px;"></svg-icon>
                            <div @click="handleRemove(hereFilelist)"><svg-icon icon-name="upload-delete" :size="16" ></svg-icon></div>
                        </template>
                    </div>
                    <div style="position: relative;margin-right: 18px;margin-left: auto;" class="progress-cls" v-if="hereFilelist.status === 'uploading'">
                        <i v-if="hereFilelist.percentage===100" class="el-icon-loading loading-cls" />
                        <div @click="removeUploading(hereFilelist)"><svg-icon icon-name="upload-delete" :size="16" ></svg-icon></div>
                    </div>
                </div>
                <el-progress
                    v-if="hereFilelist.status === 'uploading' && hereFilelist.percentage !== 100"
                    :percentage="parseInt(hereFilelist.percentage)"
                    :stroke-width="3"
                    :format="formatProgress"
                    style="width: 100%;"
                ></el-progress>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="close" class="btn cancel-btn">{{
                $t('btn_close')
            }}</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import { dateFormat } from '@/utils'
import { checkIsValidExtension } from '@/utils/fileType'
import API from '@/api'
import { userPermission } from '@/mixins/userPermission.js'
import { checkIfNeedZip, zipFile } from '@/utils/zip'
import requestUrl from '@/api/requestUrl'
import UploadTitleTips from '@/components/common/UploadTitleTips.vue'
import GuidanceTooltip from '@/components/common/GuidanceTooltip.vue'
import SvgIcon from "@/components/svgIcon/index";
import { getFileIcon } from '../../components/data.js'

export default {
    name: 'SASUpload',
    components: { UploadTitleTips, GuidanceTooltip ,SvgIcon },
    props: {
        show: { type: Boolean, default: false },
        rowData: {},
        secondMilestoneId: '',
    },
    mixins: [ userPermission ],
    data: () => ({
        onDrag: false,
        hereFilelist: [],
        // 文件上传数量限制，如果超过了限制数量，则会被从尾部切掉
        fileLimit: 50,
        notify: null,
        actionUrl: requestUrl('/client/clientStatAccState/uploadStatutoryFile'),
        headers: {},
    }),
    mounted() {
      this.headers = {
        Authorization: sessionStorage.getItem('JSESSIONID'),
        siteClassification: sessionStorage.getItem('siteClassification')
      }
    },
    methods: {
        getUploadFileIcon(filename) {
          return getFileIcon(filename);
        },
        /**
         * close 和 open，在外部可以直接调用来显示或隐藏 Dialog
         */
        close() {
            let hereFilelist = this.hereFilelist.filter(item => item.status === 'ready' || item.status === 'uploading')
            if (hereFilelist.length > 0) {
                this.$confirm(this.$t('BEFORE_CLOSE_WARING_MSG'), this.$t('COMMON_TIP'), {
                    confirmButtonText: this.$t('btn_confirm'),
                    cancelButtonText: this.$t('btn_cancel'),
                    type: 'warning'
                }).then(() => {
                    hereFilelist.forEach(item => {
                        this.$refs.uploadLog.abort(item)
                    })
                    this.$emit('afterUploadAllFinish')
                })
            } else {
                this.$emit('afterUploadAllFinish')
            }
        },
        uploading(event, file, files) {
            if (event.percent === 100 && this.notify == null) {
                this.notify = this.$message.warning({
                    message: this.$t('upload_file_valid'),
                    duration: 0,
                    showClose: true,
                    dangerouslyUseHTMLString: true,
                    onClose: () => {
                        this.notify = null
                    }
                });
            }
        },
        uploadchange(file, files) {
            if (file.status === 'success') {
            } else if(file.status !== 'fail') {
                this.hereFilelist.unshift(file)
            } else {
                // 上传失败，删除失败文件
                this.$message.error(file.name + this.$t('file_upload_failed'))
                let index = this.hereFilelist.findIndex((item) => item.name === file.name && item.uid === file.uid)
                if (index !== -1) {
                    this.hereFilelist.splice(index, 1)
                }
            }
            if (this.hereFilelist.every(item => item.status === 'success' || item.status === 'fail') && this.notify !== null) {
                this.notify.close()
                this.notify = null
            }
        },
        handleUploadSuccess(res, file, files) {
            if (res.code !== '1') {
                this.$message.error(this.$t(res.code))
                // 上传失败
                let index = this.hereFilelist.findIndex(item => item.name === file.name && item.uid === file.uid)
                if (index !== -1) {
                    this.hereFilelist.splice(index, 1)
                }
            }
        },
        beforeFileUpload(file) {
            if(this.scrollTimer) clearTimeout(this.scrollTimer)
            this.scrollTimer = setTimeout(() => {
                let overflow = document.querySelector('.overflow-fileList-container')
                overflow.scrollTop = 0
            }, 100)
            const isJPG = checkIsValidExtension(file.name);
            const isLt1G = file.size / 1024 / 1024 / 1024 < 1
            // 有50个不重名的文件则提示超出限制
            let uniqueNameFileList = []
            this.hereFilelist.forEach((v, k) => {
                if (!uniqueNameFileList.find((vv) => vv == v.name)) {
                    uniqueNameFileList.push(v.name)
                }
            })
            if (!isJPG) {
                clearTimeout(this.timer1)
                this.timer1 = setTimeout(() => {
                    this.$message.error(this.$t('PAGE_MATTERLOG_UPLOAD_TYPE'))
                }, 100)
            } else if (!isLt1G) {
                clearTimeout(this.timer2)
                this.timer2 = setTimeout(() => {
                    this.$message.error(this.$t('PAGE_PBC_UPLOAD_SIZE'))
                }, 100)
            }
            // 移除不符合上传规则的文件
            if (!isJPG || !isLt1G) {
                let index = this.hereFilelist.findIndex(item => item.uid === file.uid)
                this.hereFilelist.splice(index, 1)
            }
            return isJPG && isLt1G
        },
        handleRemove(file, fileList = []) {
            if (file.status === 'success') {
                const params = {
                  fileId: file.response.data.uploadDocumentInfo.id,
                  siteId: this.getSite.siteId
                }
                this.$confirm(this.$t('FILE_DELETE_WARNING_MSG_ONLY'), this.$t('COMMON_TIP'), {
                    confirmButtonText: this.$t('btn_confirm'),
                    cancelButtonText: this.$t('btn_cancel'),
                    type: 'warning'
                }).then(() => {
                    // 删除----
                  API.status.deleteFiles(params).then(res => {
                        if (res.code !== '1') {
                            return false
                        } else if (res.code === '1') {
                            let index = this.hereFilelist.findIndex(item => item.uid === file.uid)
                            this.hereFilelist.splice(index, 1)
                        }
                    })
                })
            }
        },
        formatProgress(percentage) {
            return percentage === 100 ? '' : `${percentage}%`;
        },
        removeUploading(file) {
            this.$refs.uploadLog.abort(file)
            let index = this.hereFilelist.findIndex(item => item.uid === file.uid)
            this.hereFilelist.splice(index, 1)
            if (this.hereFilelist.every(item => item.status === 'success' || item.status === 'fail') && this.notify !== null) {
                this.notify.close()
                this.notify = null
            }
        },
    },
    computed: {
        ...mapGetters('common', {
            getUser: 'getUser',
            getSite: 'getSite'
        }),
        uploadBtnLoading() {
            return this.hereFilelist.some(v => v.status == 'processing')
        }
    },
    beforeDestroy() {
        if (this.notify !== null) {
            this.notify.close()
            this.notify = null
        }
        if(this.scrollTimer) clearTimeout(this.scrollTimer)
    },
}
</script>
<style scoped>
    .upload-title {
        display: flex;
        flex-direction: row;
        align-items: center;
    }
    .upload-title .GuidanceTooltip {
        margin-left: 10px;
    }
    .GuidanceTooltip {
        display: flex;
        flex-direction: row;
        align-items: flex-start;;
        margin: 15px 0 15px;
    }
    .upload-title .upload-title-tip {
        font-size: 12PX;
        color:#fd349c;
        width: 80%;
        margin-left: 10px;
    }
    .upload-title .upload-title-tip i {
        color:#fd349c;
    }
    ::v-deep .el-dialog__body {
        padding: 20px;
        padding-top: 0px;
    }
    .upload-drag {
        width: 100%;
    }
    ::v-deep .upload-drag .el-upload-list {
        overflow: auto;
        max-height: 20vh;
    }
    ::v-deep .el-upload--text .el-upload-dragger{
        height: auto;
        padding: 20px;
        border-color: #4290f7;
    }
    ::v-deep .el-upload--text .el-upload-dragger .el-icon-upload {
        font-size: 50px;
        color: #3879eb;
        margin: 15px 0 15px;
        line-height: 50px;
    }
    .upload-rule-text{
        padding: 15PX 25PX;
        color: #81848a;
        margin-bottom: 15PX;
        font-size: 12PX;
    }
    .loading-cls{
        position: absolute;
        right: 24px;
        top: 0;
        color: rgb(64, 158, 255);
        cursor: pointer;
        font-size: 14px;
    }
    .del-cls{
        position: absolute;
        right: 0;
        top: 0;
        color: #fd349c;
        cursor: pointer;
        font-size: 14px;
    }
    .uploaded-cls{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 5px;
        padding-bottom: 5px;
        high: 40px;
        font-size: 14px;
    }
    .del-uploaded-cls {
        color: #fd349c;
        margin-left: 10px;
        font-size: 14px;
        cursor: pointer;
    }
    .uploaded-cls:hover{
        background-color: rgba(230, 230, 230, 0.5);
    }
    .uploaded-cls:hover .del-uploaded-cls {
        display: inline-block;
    }
    .overflow-fileList-container{
        max-height: 30vh;
        overflow: auto;
        display: grid;
        --grid-template-columns: 1fr 1fr;
        gap: 10px 5px;
        margin-top: 10px;
        transition: height 0.5s ease;
    }
    .guide-content-container{
        font-size: 12PX;
        margin-right: 30px;
    }
    .guide-tip{
        background: #00b8f5;
        border-radius: 5px;
        width: 24px;
        height: 24px;
        text-align: center;
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .border-file {
        box-sizing: border-box;
        background: #F5F8FB;
        border-radius: 5px;
        width: 98%;
    }
    .upload-filename {
        margin-left: 10px;
        width:70%;
        white-space: nowrap; /* 防止文本换行 */
        overflow: hidden; /* 隐藏超出部分 */
        text-overflow: ellipsis; /* 显示省略号 */
    }
</style>
